<!-- Vidi se samo dok server nije dostupan; nestaje sam kad se veza vrati. -->
<div class="connStatus" *ngIf="reason && variant === 'card'" role="status" aria-live="polite">
  <div class="connStatus__head">
    <mat-icon>{{ reason.key === offlineKey ? 'wifi_off' : 'cloud_off' }}</mat-icon>
    <span>{{ 'connectionStatus.title' | translate }}</span>
  </div>
  <div class="connStatus__reason">{{ reason.key | translate: reason.params }}</div>
  <div class="connStatus__retry">{{ 'connectionStatus.retrying' | translate }}</div>
</div>

<!-- Traka u aplikaciji: isti razlog, u toku sadržaja (ne prekriva dugmad). -->
<div class="connBar" *ngIf="reason && variant === 'bar'" role="status" aria-live="polite">
  <mat-icon>{{ reason.key === offlineKey ? 'wifi_off' : 'cloud_off' }}</mat-icon>
  <div class="connBar__txt">
    <div><b>{{ 'connectionStatus.title' | translate }}</b> — {{ reason.key | translate: reason.params }}</div>
    <div class="connBar__retry">{{ 'connectionStatus.retrying' | translate }}</div>
  </div>
</div>
